import { Box, Center } from '@televet/kibble-ui/build/chakra';
import { Spinner } from '@televet/kibble-ui/build/components/Spinner';
import ChannelView from 'pages/Conversations/components/ChannelView';
import React from 'react';
import useFindOrCreateActiveChannel from 'shared/hooks/useFindOrCreateActiveChannel';
import { useAppSelector } from 'state/hooks';
import { NoChannelFound } from './NoChannelFound';

const ChannelOverlay = (): JSX.Element => {
  const { channelId, draftMessageText, petParentId } = useAppSelector((state) => state.conversations.channelViewData);
  const {
    channelId: channelIdByPetParent,
    isCalled,
    isLoading,
  } = useFindOrCreateActiveChannel({ petParentId, createChannelIfNotExists: true });

  return (
    <Box pos="relative">
      <Box
        pos="absolute"
        bottom={0}
        right={4}
        bgColor="background.default"
        h="80%"
        maxH="720px"
        minH="400px"
        maxW="640px"
        minW="615px"
        borderTopRadius="lg"
        boxShadow="2xl"
        overflow="hidden"
        borderWidth="1px"
        borderBottomWidth="0"
        zIndex="banner"
      >
        {petParentId ? (
          isLoading ? (
            <Center w="100%" h="100%">
              <Spinner label="Loading conversation..." labelProps={{ size: 'md' }} showLabel={true} size="xl" />
            </Center>
          ) : channelIdByPetParent ? (
            <ChannelView channelId={channelIdByPetParent} isOverlay={true} defaultDraftMessageText={draftMessageText} />
          ) : isCalled ? (
            <NoChannelFound />
          ) : null
        ) : (
          <ChannelView channelId={channelId} isOverlay={true} defaultDraftMessageText={draftMessageText} />
        )}
      </Box>
    </Box>
  );
};

export default ChannelOverlay;
